import {type RunningTimeType} from '@hconnect/common/types'

import {type KpiDashboardPlant} from './kpi-dashboard.types'

export enum PerformanceDashboardEquipmentTypes {
  KILN = 'kiln',
  RAW_MILL = 'rawmill',
  CEMENT_MILL = 'cementMill',
  ROLLER_PRESS = 'rollerPress'
}

export type PlantStatusEquipment = {
  id: string
  name: string
  matchingId: string
  type: PerformanceDashboardEquipmentTypes
  status: RunningTimeType
  productionVolume: number
}

export type PlantEquipmentStatus = {
  plant: KpiDashboardPlant // soon deprecated
  equipments: PlantStatusEquipment[]
  actualCementProduction: number // soon deprecated
  actualClinkerProduction: number // soon deprecated
  plantId: string
}
